"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _momentRange = require("moment-range");
var _constants = _interopRequireDefault(require("./constants"));
/*
 * Map values are based on values of isoWeek of moment lib
 */
var DAY_OF_WEEK = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7
};
var momentExtended = (0, _momentRange.extendMoment)(_momentTimezone.default);
var _guessTimezone = function guessTimezone() {
  return _momentTimezone.default.tz.guess(_constants.default.IgnoreCachedTimezone);
};
/**
 * Get start day of week that is based on current date
 * isoWeekday of moment start from Monday have value 1, Tuesday have value 2...
 */
var getStartDateOfWeek = function getStartDateOfWeek(date) {
  // date of month, range value 1 -> 31
  var dateOfMonth = date.date();
  // day of week of moment, range value Monday: 1 -> Sunday: 7
  var dayOfWeek = date.isoWeekday();
  // value of each day of week of Constant, range value Monday: 1 -> Sunday: 7
  var valueOfStartWeek = DAY_OF_WEEK[_constants.default.startOfWeek];
  /*
   * Because we are based on function isoWeek of moment lib
   * isoWeek range Monday -> Sunday (1-7)
   * then DAY_OF_WEEK['Sunday'] = 7 only correct with
   * case start day of Week IS Sunday And current day IS Sunday too
   * If not we will change value to 0
   * to ensure that Sunday we calculate in correct range
   * Example: start day of week is Sunday And current day is 10-11-2018 (Saturday DD-MM-YYY)
   * then Sunday must be 04-11-2018 (DD-MM-YYYY) (correct)
   * NOT 11-11-2018 (DD-MM-YYY) (incorrect)
   *
   * rootcause incorrect: range week of isoWeek moment start Mon->Sun
   * so 11-11-2018 still in range current week of isoweek 05->011 (Mon->Sun)
   * But with start of Week is Sunday, our week range is Sun-Sat means 04-10
   */
  if (_constants.default.startOfWeek === 'Sunday' && dayOfWeek !== DAY_OF_WEEK[_constants.default.startOfWeek]) {
    valueOfStartWeek = 0;
  }
  /*
   * return number Date of Month
   * Example: if we want to set date to 04-11-2018 (DD-MM-YYYY)
   * then this return number is 04
   */
  return dateOfMonth - dayOfWeek + valueOfStartWeek;
};
var DateUtil = {
  createListOfHours: function createListOfHours(startHour, endHour, timezone) {
    var step = _constants.default.TimeConstraint.minutes.step;
    // 1 AM
    var startTime = _momentTimezone.default.tz(timezone).startOf('day').add(0, 'hours');
    var endTime = _momentTimezone.default.tz(timezone).endOf('day');
    var result = [];
    startTime = startHour ? startTime.hour(startHour.hour()).minute(startHour.minute()) : startTime;
    if (endHour) {
      endTime = _momentTimezone.default.tz(timezone).hour(endHour.hour()).minute(endHour.minute()).add(step, 'minutes');
    }
    do {
      result.push({
        label: startTime.format(_constants.default.DateTimeFormat.shortTimeAMPM),
        value: startTime.format(_constants.default.DateTimeFormat.shortTimeAMPM),
        dateValue: (0, _momentTimezone.default)(startTime)
      });
      startTime.add(step, 'minutes');
    } while (startTime.isBefore(endTime, 'minutes'));
    return result;
  },
  getDayOfWeek: function getDayOfWeek(time) {
    return (0, _momentTimezone.default)(time).format(_constants.default.DateTimeFormat.dayOfWeek);
  },
  utc: function utc(date) {
    return _momentTimezone.default.utc(date);
  },
  /**
   * Change time zone and keep the same local time,
   * but at the expense of choosing a different point in Universal Time.
   * If timezone is not set, then the local timezone will be used
   */
  changeTimezone: function changeTimezone(date) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _guessTimezone();
    return (0, _momentTimezone.default)(date).utcOffset((0, _momentTimezone.default)(date).tz(timezone).utcOffset(), true);
  },
  format: function format(date, _format) {
    return (0, _momentTimezone.default)(date).format(_format);
  },
  formatUTC: function formatUTC(date, format, timezone) {
    return _momentTimezone.default.utc(date).tz(timezone).format(format);
  },
  getDateInTimezone: function getDateInTimezone(date) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _guessTimezone();
    return (0, _momentTimezone.default)(date).tz(timezone);
  },
  copyDate: function copyDate(dateTarget, dateSource) {
    var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var timezone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _guessTimezone();
    var target = DateUtil.getDateInTimezone(dateTarget, timezone);
    var source = DateUtil.getDateInTimezone(dateSource, timezone);
    return _lodash.default.reduce(units, function (date, unit) {
      return (0, _momentTimezone.default)(date).set(unit, source.get(unit));
    }, target);
  },
  getTimestampInSecond: function getTimestampInSecond(value) {
    return (0, _momentTimezone.default)(value).unix();
  },
  guessTimezone: function guessTimezone() {
    return _guessTimezone();
  },
  isOverlaps: function isOverlaps(range1, range2) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var newRange1 = range1;
    var newRange2 = range2;
    if (options.timeOnly) {
      var timezone = _lodash.default.get(options, 'timezone', _guessTimezone());
      var currentDate = DateUtil.getDateInTimezone(new Date(), timezone);
      var convertTime = function convertTime(range) {
        var r = DateUtil.getDateInTimezone(range, timezone);
        return (0, _momentTimezone.default)(currentDate).hour(r.hour()).minute(r.minute()).second(0);
      };
      newRange1 = _lodash.default.map(range1, convertTime);
      newRange2 = _lodash.default.map(range2, convertTime);
    }
    newRange1 = momentExtended.range(newRange1);
    newRange2 = momentExtended.range(newRange2);
    return newRange1.overlaps(newRange2);
  },
  isRangeSame: function isRangeSame(range1, range2) {
    var newRange1 = momentExtended.range(range1);
    var newRange2 = momentExtended.range(range2);
    return newRange1.isSame(newRange2);
  },
  getGroupAvailableTimes: function getGroupAvailableTimes(slots, hoursStart, hoursEnd, timezone) {
    return _lodash.default.filter(slots, function (o) {
      var convertStartTime = DateUtil.getDateInTimezone(_momentTimezone.default.unix(o), timezone).hour(hoursStart[0]).minutes(hoursStart[1]);
      var convertEndTime = DateUtil.getDateInTimezone(_momentTimezone.default.unix(o), timezone).hour(hoursEnd[0]).minutes(hoursEnd[1]);
      var currentDate = DateUtil.getDateInTimezone(_momentTimezone.default.unix(o), timezone);
      return (0, _momentTimezone.default)(currentDate).isBetween(convertStartTime, convertEndTime) || (0, _momentTimezone.default)(currentDate).isSame(convertStartTime) || (0, _momentTimezone.default)(currentDate).isSame(convertEndTime);
    });
  },
  getStartOfWeek: function getStartOfWeek(date) {
    var numberOfDateOfMonth = getStartDateOfWeek(date);
    return (0, _momentTimezone.default)(date).date(numberOfDateOfMonth).startOf('day');
  },
  getEndOfWeek: function getEndOfWeek(date) {
    var numberDayInWeek = 6;
    var numberOfDateOfMonth = getStartDateOfWeek(date) + numberDayInWeek;
    return (0, _momentTimezone.default)(date).date(numberOfDateOfMonth).endOf('day');
  },
  getEffectiveDate: function getEffectiveDate(effectiveDate, serverTimestamp, timezone) {
    var currentDate = DateUtil.getDateInTimezone(serverTimestamp, timezone);
    var effective = DateUtil.getDateInTimezone(effectiveDate, timezone);
    return effective.isSameOrBefore(currentDate, 'day') ? currentDate.add(1, 'day') : effective;
  },
  parseDate: function parseDate(date, format, timezone) {
    return _momentTimezone.default.utc(date, format).tz(timezone);
  },
  formatShortTime: function formatShortTime(time, timezone) {
    return this.formatUTC(time, _constants.default.DateTimeFormat.shortTimeAMPM, timezone);
  },
  getLocalTzAbbreviation: function getLocalTzAbbreviation() {
    return _momentTimezone.default.tz(_guessTimezone()).format('z');
  },
  getTzAbbreviation: function getTzAbbreviation(date, zoneName) {
    var dateTime = (0, _momentTimezone.default)(date).isValid() ? (0, _momentTimezone.default)(date) : (0, _momentTimezone.default)();
    return date ? dateTime.tz(zoneName).format('z') : _momentTimezone.default.tz(zoneName).format('z');
  },
  getDateAndTimeStringInTimezone: function getDateAndTimeStringInTimezone(date) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _guessTimezone();
    return (0, _momentTimezone.default)(date).tz(timezone).format(_constants.default.DateTimeFormat.EXECUTION_DATE_TIME);
  },
  getCustomTimezoneName: function getCustomTimezoneName(date, timezone) {
    if (!_momentTimezone.default.isMoment(date) || !date.isValid()) {
      return '';
    }
    var abbr = date.tz(timezone).format('z');
    var offset = _lodash.default.parseInt(date.tz(timezone).format('Z'));
    return "(".concat(abbr, ") ").concat(timezone, " ").concat(offset, "h");
  }
};
var _default = DateUtil;
exports.default = _default;